import { render, staticRenderFns } from "./OnsDataSocComponent.vue?vue&type=template&id=44816778&lang=pug"
import script from "./OnsDataSocComponent.vue?vue&type=script&lang=ts"
export * from "./OnsDataSocComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports